import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Mark from './Mark';
import './Navbar.css';

const navLinks = [
  { to: '/',            label: 'Home' },
  { to: '/map',         label: 'Area Map' },
  { to: '/noticeboard', label: 'Noticeboard' },
  { to: '/about',       label: 'About' },
  { to: '/contact',     label: 'Contact' },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const close = () => setOpen(false);

  const handleJoin = () => { close(); navigate('/join'); };

  return (
    <header className="nav">
      <div className="nav-inner wrap">
        <NavLink to="/" className="brand" onClick={close}>
          <Mark />
          <span className="brand-text">
            <span className="brand-name">CWARA</span>
            <span className="brand-sub">Carlisle &amp; Waverley Residents</span>
          </span>
        </NavLink>

        <button
          className="nav-toggle"
          onClick={() => setOpen(o => !o)}
          aria-label="Toggle navigation"
          aria-expanded={open}
        >
          {open ? '✕' : '☰'}
        </button>

        <nav className={'nav-links' + (open ? ' open' : '')} aria-label="Main navigation">
          {navLinks.map(({ to, label }) => (
            <NavLink
              key={to}
              to={to}
              end={to === '/'}
              className={({ isActive }) => 'nav-link' + (isActive ? ' active' : '')}
              onClick={close}
            >
              {label}
            </NavLink>
          ))}
          <button className="btn btn-primary btn-sm nav-cta" onClick={handleJoin}>
            Join — it's free
          </button>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
